import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute() {
  const { user, loading } = useAuth();

  console.log("[ProtectedRoute] loading:", loading, "user:", user);

  if (loading) return <div>Loading...</div>;

  // ✅ Strict: only allow if user exists AND has an id/email/role (adjust to your user shape)
  const isAuthed = !!(user && (user.id || user._id || user.email));

  return isAuthed ? <Outlet /> : <Navigate to="/login" replace />;
}
